import { action, configure, decorate, observable, runInAction } from 'mobx';
import { error, fetchData, RootStore } from './RootStore';

configure({ enforceActions: 'observed' });

export type PageProps = {
  pageContent: string;
  pageId: string;
  pageName: string;
  pageShortName: string;
  pageUrl: string;
  pagePath: string;
  pageRHS: string | null;
  dateStamp: string | null;
};

export class PageStore {
  rootStore: RootStore;
  pages: { [key: string]: PageProps };
  currentPage: PageProps | null;
  isPending: boolean;
  error: error;
  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    this.pages = {};
    this.isPending = true;
    this.error = null;
    this.currentPage = null;
  }

  setCurrentPage = async (currentPagePath: string) => {
    const requestUrl = `${process.env.REACT_APP_API || ''}${currentPagePath}?${process.env
      .REACT_APP_JSON_DESIGN || ''}&${process.env.REACT_APP_JSON_PAGE || ''}`;

    if (this.pages[requestUrl]) {
      this.currentPage = this.pages[requestUrl];
      return;
    }

    this.isPending = true;
    this.currentPage = null;
    this.error = null;

    try {
      const page: PageProps = await fetchData(requestUrl);
      runInAction(() => {
        this.isPending = false;
        this.error = null;
        this.currentPage = page;
        this.pages = { ...this.pages, [requestUrl]: page };
      });
    } catch (error) {
      runInAction(() => {
        this.currentPage = null;
        this.error = { name: error.name, message: error.message };
        this.isPending = false;
      });
    }
  };
}

decorate(PageStore, {
  currentPage: observable,
  error: observable,
  isPending: observable,
  setCurrentPage: action,
});
